/**
 * @generated SignedSource<<09c409db3757077334e0a4e5cdcd4ee6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FactSheetVisibilityInputObject = {
  key: string;
  visible: boolean;
};
export type factSheetSettingsPage_ConfigSetMutation$variables = {
  visibility: ReadonlyArray<FactSheetVisibilityInputObject>;
};
export type factSheetSettingsPage_ConfigSetMutation$data = {
  readonly factSheetConfigSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly user: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type factSheetSettingsPage_ConfigSetMutation = {
  response: factSheetSettingsPage_ConfigSetMutation$data;
  variables: factSheetSettingsPage_ConfigSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibility"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "factSheetSettingsPage_ConfigSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FactSheetConfigSetMutationPayload",
        "kind": "LinkedField",
        "name": "factSheetConfigSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "factSheetSettingsPage_ConfigSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FactSheetConfigSetMutationPayload",
        "kind": "LinkedField",
        "name": "factSheetConfigSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef2a98a317792e253a79b6165e550f62",
    "id": null,
    "metadata": {},
    "name": "factSheetSettingsPage_ConfigSetMutation",
    "operationKind": "mutation",
    "text": "mutation factSheetSettingsPage_ConfigSetMutation(\n  $visibility: [FactSheetVisibilityInputObject!]!\n) {\n  factSheetConfigSet(visibility: $visibility) {\n    user {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9659c8f932964e62e73c49ed6715b667";

export default node;
